import { Stack } from '@mui/material';
import { FC, MouseEvent } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { Permission } from '@/api/permissions';
import ArrowRight from '@/assets/svg/ui-elements/arrow-light-right.svg';
import MailIcon from '@/assets/svg/ui-elements/mail.svg';
import UsersGroupRoundedIcon from '@/assets/svg/ui-elements/users-group-rounded.svg';
import { IconButton, Tooltip } from '@/design-system';
import { getCommunicationContactPath } from '@/pages/communications-v2/utils/get-communication-contact-path';
import { getManageEntityReviewOrEditPath } from '@/pages/create-entity/utils/entity-review-routing';
import { PagePaths } from '@/routes/page-paths';
import { useCan } from '@/shared/modules/permissions';

import { EntityTabTableRow } from '../data';

type Props = Pick<EntityTabTableRow, 'id' | 'fullName' | 'status'>;

export const EntitiesTabTableActions: FC<Props> = ({ id, status }) => {
  const navigate = useNavigate();
  const canReviewCrossEntity = useCan(Permission.GlobalAdminCrossEntityAccess);
  const communicationPath = getCommunicationContactPath({
    recipientType: 'EntityDesk',
    recipientId: id,
  });

  const onRedirect = (e: MouseEvent) => {
    e.stopPropagation();
    navigate(
      getManageEntityReviewOrEditPath({ id, canReviewCrossEntity, entityApprovalStatus: status }),
    );
  };
  const onContact = (e: MouseEvent) => {
    e.stopPropagation();
    navigate(communicationPath);
  };
  const onManageTeam = (e: MouseEvent) => {
    e.stopPropagation();
    navigate(generatePath(PagePaths.manageTeamEntityId, { id }));
  };

  return (
    <Stack gap="8px">
      <IconButton variant="outline" size="sm" onClick={onContact}>
        <MailIcon />
      </IconButton>
      <Tooltip title="Manage Team">
        <IconButton variant="outline" size="sm" onClick={onManageTeam}>
          <UsersGroupRoundedIcon />
        </IconButton>
      </Tooltip>
      <IconButton variant="outline" size="sm" onClick={onRedirect}>
        <ArrowRight />
      </IconButton>
    </Stack>
  );
};
